import React from 'react';
import Section from './Section';

const socials = [
    { name: 'GitHub', href: 'https://github.com/devnamrits' },
    { name: 'LinkedIn', href: 'https://www.linkedin.com/in/devnamrits/' },
    { name: 'X', href: 'https://twitter.com/devnamrits' },
];

export default function Contact() {
    return (
        <Section id="contact" title="Contact">
            <p>
                Open to LLM / Applied AI / backend-heavy roles. Email is
                fastest — I reply to everything, usually within a day.
            </p>
            <p>
                <a className="email" href="mailto:devnamrits@gmail.com">
                    devnamrits@gmail.com
                </a>
            </p>
            <p className="socials">
                {socials.map((s, i) => (
                    <React.Fragment key={s.name}>
                        {i > 0 && ' · '}
                        <a href={s.href} target="_blank" rel="noreferrer">
                            {s.name}
                        </a>
                    </React.Fragment>
                ))}
            </p>
        </Section>
    );
}
